import { Check } from "@phosphor-icons/react"
import { HighlightText } from "@/components/highlight-text"
import { SearchItem } from "@/components/ui/search"
import { cn } from "@/lib/utils"

type SearchOptionProps = {
  searchValue: string
  title: string
  synonym?: string | null
  value: string
  onSelect: (value: string) => void
  icon?: React.JSX.Element
  description?: string
  className?: string
  checked?: boolean
}

const SearchOption = ({
  searchValue,
  onSelect,
  value,
  title,
  synonym,
  icon,
  description,
  className,
  checked,
}: SearchOptionProps) => {
  const normalizedSearchValue = searchValue.length >= 3 ? searchValue.trim().toLowerCase() : ""

  return (
    <SearchItem
      className={cn(
        "flex justify-between overflow-hidden rounded-md py-1.5",
        checked && "bg-primary-surface! hover:bg-primary-surface-hovered!",
        className,
      )}
      onSelect={() => onSelect(value)}
      value={value}>
      <div className="grid-cols-auto-1fr grid items-center gap-2" data-testid={`${value.toLowerCase()}-search-option`}>
        {icon && <span className="text-on-surface-subdued">{icon}</span>}
        <div className="flex flex-col">
          {/* oxlint-disable-next-line typescript/no-deprecated */}
          <HighlightText
            className={cn("text-on-surface text-sm text-clip", checked && "text-on-primary-surface")}
            text={title}
            searchValue={normalizedSearchValue}
            extendedMarkClasses="font-normal"
          />
          {synonym && (
            /* oxlint-disable-next-line typescript/no-deprecated */
            <HighlightText
              className="text-on-surface-subdued text-xs leading-4 tracking-[0.25px] text-clip"
              text={synonym}
              searchValue={normalizedSearchValue}
              extendedMarkClasses="font-normal"
            />
          )}
          {description && (
            <span
              className={cn(
                "text-on-surface-subdued truncate text-xs leading-4 font-normal tracking-[0.25px]",
                checked && "text-on-primary-surface",
              )}>
              {description}
            </span>
          )}
        </div>
      </div>
      {checked && <Check className="text-on-primary-surface" />}
    </SearchItem>
  )
}

export { SearchOption }
